import React from 'react';
import AmendContractDetailsTable from './AmendContractDetailsTable';
import AmendContractForm from './AmendContractForm';

export default function AmendContractDetails(props) {
	let screen = props.displaySubScreen;

	switch (screen) {
		case 'detailsTable': {
			return <AmendContractDetailsTable {...props} />;
		}
		case 'detailsForm': {
			return <AmendContractForm {...props} />;
		}
		case '':
		default:
			return null;
	}
}
